import { render, staticRenderFns } from "./BannerClient.vue?vue&type=template&id=705705b7&scoped=true"
import script from "./BannerClient.vue?vue&type=script&lang=js"
export * from "./BannerClient.vue?vue&type=script&lang=js"
import style0 from "./BannerClient.vue?vue&type=style&index=0&id=705705b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705705b7",
  null
  
)

export default component.exports